import { getImg } from '@/utils/matchAsset'

export const matchNavList = [
  { key: 'news', label: '赛事资讯', labelEn: 'INFORMATION', targetId: 'match-news', active: true, theme: 'highlight' },
  { key: 'details', label: '赛事详情', labelEn: 'EVENT DETAILS', targetId: 'match-details' },
  { key: 'video', label: '视频中心', labelEn: 'VIDEO CENTER', targetId: 'video-center' },
  { key: 'venue', label: '观赛地址', labelEn: 'WATCHING VENUE', route: '/match/signup', anchor: 'watch-address', theme: 'venue' },
  { key: 'progress', label: '赛事进程', labelEn: 'PROGRESS', targetId: 'match-progress' },
  { key: 'benefits', label: '福利奖励', labelEn: 'BENEFITS', targetId: 'match-benefits' },
]

export const matchHeroData = {
  heroBg: getImg('match/pc/match/hero-bg.png'),
  mobileHeroBg: getImg('match/pc/match/mobile-home-hero-bg.jpg'),
  navBg: getImg('match/pc/match/nav-bg.png'),
  alt: '千年争霸赛',
  ctaIcon: getImg('match/pc/match/cta-go.png'),
  ctaText: '报名参战',
  ctaSubText: '',
}
